import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import AnalyticsActionTypes from '../actionTypes/AnalyticsActionTypes';

import StyliticsActionFilter from '../analytics/StyliticsActionFilter';

const styliticsActionFilter = new StyliticsActionFilter();

const AnalyticsMiddleware = () => (next) => (action) => {
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;

        switch (action.type) {
            case AnalyticsActionTypes.SHOP_THE_IMAGE_ITEM_CLICK: {
                digitalData = styliticsActionFilter.getShopTheImageItemClick(action.payload);
                analyticsEventName = 'shopTheImageDetail';
                break;
            }

            case AnalyticsActionTypes.SHOP_THE_IMAGE_LOAD_SUCCESS: {
                digitalData = styliticsActionFilter.getShopTheImageLoadSuccess(action.payload);
                analyticsEventName = 'digitalDataReady';
                break;
            }

            case AnalyticsActionTypes.SHOP_THE_IMAGE_MODULE_CLICK: {
                digitalData = styliticsActionFilter.getShopTheImageModuleClick(action.payload);
                analyticsEventName = 'shopTheImage';
                break;
            }

            case AnalyticsActionTypes.STYLED_FOR_YOU_ITEM_CLICK: {
                digitalData = styliticsActionFilter.getStyledForYouItemClick(action.payload);
                analyticsEventName = 'styledForYouDetail';
                break;
            }

            case AnalyticsActionTypes.STYLED_FOR_YOU_LOAD_SUCCESS: {
                digitalData = styliticsActionFilter.getStyledForYouLoadSuccess(action.payload);
                analyticsEventName = 'digitalDataReady';
                break;
            }

            case AnalyticsActionTypes.STYLED_FOR_YOU_MODULE_CLICK: {
                digitalData = styliticsActionFilter.getStyledForYouModuleClick(action.payload);
                analyticsEventName = 'styledForYou';
                break;
            }

            default:
                break;
        }

        /* istanbul ignore else */
        if (analyticsEventName || digitalData) {
            analytics.track(analyticsEventName, digitalData);
        }
    }
    return next(action);
};

export default AnalyticsMiddleware;
